// extracted by mini-css-extract-plugin
module.exports = {"icon":"ModalFailure_icon__plP6i","title":"ModalFailure_title__EhjWd","description":"ModalFailure_description__JdiI_","debug":"ModalFailure_debug__7srzB"};